import { setIsBranchInitialized, setDeepLinkPath, setBranchTokens } from 'Core_Redux/deepLink';
import { BranchDeepLinks } from 'capacitor-branch-deep-links';
import branch from 'branch-sdk';

export const initializePwaBranch = (store) => {
  return new Promise((resolve, reject) => {
    try {
      // Add timeout to prevent hanging
      const timeoutId = setTimeout(() => {
        reject(new Error('Branch initialization timed out after 10 seconds'));
      }, 10000);

      // Branch web/pwa api
      branch.init(process.env.BRANCH_API_KEY, {}, async (err, data) => {
        if (err) reject(err);
        clearTimeout(timeoutId);
        await handleBranchInitialization(store, data?.data_parsed);
        resolve();
      });
    } catch (err) {
      reject(err);
    }
  });
};

export const initializeBinaryBranch = async (store) => {
  return await new Promise((resolve, reject) => {
    try {
      // Add timeout to prevent hanging
      const timeoutId = setTimeout(() => {
        reject(new Error('Branch initialization timed out after 10 seconds'));
      }, 10000);

      // Branch iOS/Android api
      BranchDeepLinks.addListener('init', async (event) => {
        clearTimeout(timeoutId);
        await handleBranchInitialization(store, event?.referringParams);
        resolve();
      });

      // Initialize Branch explicitly
      BranchDeepLinks.initialize();
    } catch (err) {
      reject(err);
    }
  });
};

const handleBranchInitialization = async (store, branchData) => {
  if (branchData?.custom_object?.access_token && branchData?.custom_object?.refresh_token) {
    await store.dispatch(
      setBranchTokens({
        accessToken: branchData.custom_object.access_token,
        refreshToken: branchData.custom_object.refresh_token,
      }),
    );
  }

  if (branchData?.['$deeplink_path']) {
    await store.dispatch(setDeepLinkPath(branchData['$deeplink_path']));
  }

  await store.dispatch(setIsBranchInitialized(true));
};
